import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';
import styles from './sgiCalculator.module.scss';

/**
 * To show savings calculator
 */
function SgiCalculator({ headline = '', guid = '', orgGuid = '' }) {
  return (
    <>
      <Script
        id="sgi-calculator"
        src={`https://embed.signalintent.com/js/embedded.js?org-guid=${orgGuid}`}
        onLoad={() => {
          if (window.Chimney?.calculators?.isLoaded === false) {
            window.Chimney.calculators.loadCalculatorsAssets();
            window.Chimney.calculators.isLoaded = true;
          }
        }}
      />
      <div className={styles.sgiCalculatorContainer}>
        {headline ? <h2 className={styles.headLine}>{headline}</h2> : null}
        <div id="sgi" data-guid={guid} />
      </div>
    </>
  );
}

SgiCalculator.propTypes = {
  headline: PropTypes.string,
  guid: PropTypes.string,
  orgGuid: PropTypes.string,
};
export default SgiCalculator;
